import { testimonials } from '@/mocks/categories';

export default function TrustSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest uppercase text-secondary-600 whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-secondary-500"></span>
            Community Reviews
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mt-3">
            Trusted by Shoppers
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-md mx-auto">
            Real feedback from people who use the Superbuy Spreadsheet every day.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl p-6 border border-background-200/60 transition-all duration-300 hover:border-background-300/80"
            >
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {t.headline}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {t.content}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                  <span className="text-xs font-semibold text-secondary-700">
                    {t.name.split(' ').map((n) => n[0]).join('')}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}